// components/hooks/useLoadActiveData.js

import { useState, useEffect, useMemo } from "react";
import { useAuth } from "../components/context/AuthContext";

export const useLoadActiveData = (filterParams = {}, trigger = 0) => {
  const { fetchWithAuth, accessToken, handleLogout } = useAuth();

  const [kategorienAktiv, setKategorienAktiv] = useState([]);
  const [ablageorteAktiv, setAblageorteAktiv] = useState([]);
  const [typenAktiv, setTypenAktiv] = useState([]);
  const [laenderAktiv, setLaenderAktiv] = useState([]);
  const [materialienAktiv, setMaterialienAktiv] = useState([]);
  const [waehrungenAktiv, setWaehrungenAktiv] = useState([]);
  const [zustaendeAktiv, setZustaendeAktiv] = useState([]);
  const [eigentuemerAktiv, setEigentuemerAktiv] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const queryString = new URLSearchParams(
    Object.entries(filterParams).filter(([_, val]) => val !== "")
  ).toString();

  const isReady =
    filterParams &&
    accessToken &&
    Object.values(filterParams).some(v => v !== undefined);

  useEffect(() => {
    if (!accessToken) return;

    const fetchActiveData = async () => {
      try {
        setLoading(true);
        setError(null);

        const queryString = new URLSearchParams(
          Object.entries(filterParams).filter(([_, val]) => val !== "" && val !== null)
        ).toString();

        const [
          kategorienActiveResponse,
          ablageorteActiveResponse,
          typenActiveResponse,
          laenderActiveResponse,
          materialienActiveResponse,
          waehrungenActiveResponse,
          zustaendeActiveResponse,
          eigentuemerActiveResponse
        ] = await Promise.all([
          fetchWithAuth(`/api/data/kategorien_a?${queryString}`),
          fetchWithAuth(`/api/data/ablageorte_a?${queryString}`),
          fetchWithAuth(`/api/data/typen_a?${queryString}`),
          fetchWithAuth(`/api/data/laender_a?${queryString}`),
          fetchWithAuth(`/api/data/materialien_a?${queryString}`),
          fetchWithAuth(`/api/data/waehrungen_a?${queryString}`),
          fetchWithAuth(`/api/data/zustaende_a?${queryString}`),
          fetchWithAuth(`/api/data/eigentuemer_a?${queryString}`)
        ]);

        if (
          !kategorienActiveResponse.ok ||
          !ablageorteActiveResponse.ok ||
          !typenActiveResponse.ok ||
          !laenderActiveResponse.ok ||
          !materialienActiveResponse.ok ||
          !waehrungenActiveResponse.ok ||
          !zustaendeActiveResponse.ok ||
          !eigentuemerActiveResponse.ok
        ) {
          throw new Error("REST-Response: Fehler beim Laden der Daten");
        }

        setKategorienAktiv(await kategorienActiveResponse.json());
        setAblageorteAktiv(await ablageorteActiveResponse.json());
        setTypenAktiv(await typenActiveResponse.json());
        setLaenderAktiv(await laenderActiveResponse.json());
        setMaterialienAktiv(await materialienActiveResponse.json());
        setWaehrungenAktiv(await waehrungenActiveResponse.json());
        setZustaendeAktiv(await zustaendeActiveResponse.json());
        setEigentuemerAktiv(await eigentuemerActiveResponse.json());

      } catch (err) {
        setError(err.message);
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchActiveData();
  }, [
    accessToken,
    filterParams.kategorie,
    filterParams.ablageort,
    filterParams.typ,
    filterParams.land,
    filterParams.material,
    filterParams.waehrung,
    filterParams.zustand,
    filterParams.eigentuemer
  ]);

  return {
    kategorienAktiv,
    ablageorteAktiv,
    typenAktiv,
    laenderAktiv,
    materialienAktiv,
    waehrungenAktiv,
    zustaendeAktiv,
    eigentuemerAktiv,

    loading,
    error
  };
};
